import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://admin.local.dev:8080'}/api`;

class CollectionService {
  async list() {
    const response = await axios.get(`${API_URL}/platform/collections/list`);
    return response.data.data || [];
  }

  async get(id) {
    const response = await axios.get(`${API_URL}/platform/collections/get/${id}`);
    return response.data.data;
  }

  async save(payload) {
    const response = await axios.post(`${API_URL}/platform/collections/save`, payload);
    return response.data.data;
  }

  async update(id, payload) {
    const response = await axios.post(`${API_URL}/platform/collections/update/${id}`, payload);
    return response.data.data;
  }

  async delete(id) {
    await axios.post(`${API_URL}/platform/collections/delete/${id}`);
  }
}

const collectionService = new CollectionService();

export default collectionService;
